// Textos de justificativa pré-preenchidos em cada modal da Circularização — o auditor pode manter
// como está ou reescrever livremente; o campo nunca é travado/readonly. Pedido do usuário: reduzir
// o atrito de ter que digitar uma justificativa do zero em toda ação, sem abrir mão da trilha de
// auditoria (a justificativa continua sendo salva de verdade, só o texto inicial muda).
import { CartaStatus, StatusValidacaoResposta } from '../interfaces/ICircularizacao';

export const JUSTIFICATIVA_PADRAO_INCLUSAO =
  'Empresa incluída pelo auditor em razão da necessidade de confirmação de operações relevantes não contempladas na seleção preliminar.';

export const JUSTIFICATIVA_PADRAO_EXCLUSAO =
  'Circularização considerada desnecessária após avaliação do auditor.';

export const JUSTIFICATIVA_PADRAO_EXCLUSAO_LOTE =
  'Empresas excluídas da circularização após revisão em lote pelo auditor.';

export const JUSTIFICATIVA_PADRAO_EDICAO =
  'Correção de dados cadastrais do destinatário para adequada identificação na carta de circularização.';

export const JUSTIFICATIVA_PADRAO_RENOMEIO =
  'Ajuste do nome de exibição solicitado pelo auditor, sem alteração da razão social original.';

export const JUSTIFICATIVA_PADRAO_NAO_APLICAVEL =
  'Categoria não aplicável para esta empresa/período — não há destinatários identificados nesta categoria.';

const JUSTIFICATIVA_CONCLUSAO_POR_STATUS: Partial<Record<CartaStatus, string>> = {
  CONCORDANTE: 'Resposta concordante recebida e validada — saldo/informação confirmado sem divergências.',
  DIVERGENTE: 'Resposta divergente recebida — divergência identificada e tratada conforme procedimentos de auditoria.',
  PARCIAL: 'Resposta parcial recebida — informações parcialmente confirmadas, tratamento concluído conforme julgamento profissional.',
  INCONCLUSIVA: 'Resposta inconclusiva — procedimentos alternativos de auditoria aplicados para conclusão do item.',
  RECUSA: 'Recusa de resposta registrada — procedimentos alternativos de auditoria aplicados.',
  PROCEDIMENTO_ALTERNATIVO: 'Procedimento alternativo de auditoria aplicado e documentado para conclusão do item.',
};

export const justificativaPadraoConclusao = (status: CartaStatus): string =>
  JUSTIFICATIVA_CONCLUSAO_POR_STATUS[status] ?? 'Procedimento de circularização concluído após análise do auditor.';

const JUSTIFICATIVA_CLASSIFICACAO_POR_STATUS: Record<StatusValidacaoResposta, string> = {
  CANDIDATA: '',
  EM_ANALISE: '',
  CONCORDANTE: 'Saldo/informação confirmado pelo destinatário sem divergências em relação ao registrado.',
  DIVERGENTE: 'Valor ou informação informada pelo destinatário diverge do registrado — divergência identificada.',
  PARCIAL: 'Destinatário confirmou parcialmente as informações solicitadas.',
  INCONCLUSIVA: 'Resposta recebida não permite conclusão objetiva sobre a confirmação solicitada.',
  RECUSA: 'Destinatário recusou-se a confirmar as informações solicitadas.',
};

export const justificativaPadraoClassificacao = (status: StatusValidacaoResposta): string =>
  JUSTIFICATIVA_CLASSIFICACAO_POR_STATUS[status] ?? '';
